import React from "react";
import PropTypes from "prop-types";

export const AskAnExpertAlert = props => {
  return (
    <div className="form-error input-error" role="alert">
      {props.message}
    </div>
  );
};

AskAnExpertAlert.propTypes = {
  message: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// src/client/components/site/features/askanexpert/form/AskAnExpertAlert.js